<template>
  <div
    class="w-full bg-gray-200 h-2 relative overflow-hidden"
    :class="[{ 'rounded-full': rounded }, { indeterminate: indeterminate }]"
  >
    <div
      class="h-full progressbar transition-colors"
      :class="[
        `bg-${color || autoColor}`,
        { 'absolute top-0': indeterminate },
        { 'rounded-full': rounded }
      ]"
      role="progressbar"
      :style="{ width: `${percentage}%` }"
      :aria-valuenow="percentage"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <span
        style="font-size: 8px; height: 100%; mix-blend-mode: difference;"
        class="pl-1 text-white w-full whitespace-nowrap flex justify-start"
      >
        {{ text || `${percentage.toFixed(0)}%` }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      default: 0
    },
    text: {
      type: String,
      default: null
    },
    rounded: {
      type: Boolean,
      default: true
    },
    max: {
      type: Number,
      default: 100
    },
    indeterminate: Boolean
  },
  computed: {
    percentage() {
      return (this.value / this.max) * 100;
    },
    autoColor() {
      if (this.percentage < 20) {
        return "red-600";
      } else if (this.percentage < 95) {
        return "yellow-500";
      }
      return "secondary";
    }
  }
};
</script>
<style scoped>
@keyframes progress-indeterminate {
  0% {
    width: 30%;
    left: -40%;
  }
  60% {
    left: 100%;
    width: 100%;
  }
  to {
    left: 100%;
    width: 0;
  }
}
.progressbar {
  transition: width 0.25s ease;
}
.indeterminate .progressbar {
  animation: progress-indeterminate 1.4s ease infinite;
}
</style>
